/**
 * Окна, которые не заводят собственного стора, но занимают экран не меньше остальных.
 *
 * Отдельный модуль, а не флаг в `app-update`, потому что это не состояние приложения, а факт
 * «прямо сейчас с человеком разговаривает кто-то другой». Читают его двое: `isScreenBusy`
 * снимком, а веб-шторка разрешений подпиской, потому что ей мало знать, занят ли экран
 * сейчас: она должна показаться, когда чужое окно закроется.
 */
let postNudgeVisible = false;

const listeners = new Set<() => void>();

/** Окно «назначь сессию», которое встречает человека сразу после созданной заявки. */
export const setPostNudgeVisible = (visible: boolean) => {
  if (postNudgeVisible === visible) {
    return;
  }
  postNudgeVisible = visible;
  listeners.forEach((notify) => notify());
};

export const isPostNudgeVisible = () => postNudgeVisible;

/**
 * Подписка на занятость экрана.
 *
 * Нужна из-за порядка монтирования: то же самое создание заявки и открывает это окно, и
 * поднимает повод спросить про уведомления. Оба происходят в одном такте, и без подписки
 * шторка разрешений либо легла бы поверх чужого окна, либо не показалась бы вовсе.
 */
export const subscribeScreenFlags = (listener: () => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};
